module.exports = __webpack_public_path__ + "static/img/img_qrcode.363f7d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_qrcode.png
// module id = TtbA
// module chunks = 1